import {EstimateDetailTypeEnum} from "../enums/estimate/estimate.enum";
import {InvoiceStatusEnum, InvoiceTermEnum} from "../enums/invoice/invoice.enum";
import {Address} from "../interfaces/address.interface";
import {EstimateStatusProps} from "../interfaces/estimate/estimate.interface";
import {Files} from "../interfaces/files.interface";
import {IPayment} from "../interfaces/payment/payment.interface";
import {TaxEntity} from "../interfaces/tax/tax.interface";
import {
  DropDownDTO,
  EstimateCostLineItemsEntityDTO,
  EstimateEntityDTO,
  EstimateFilesDTO
} from "../modals/estimate.modal";

export class InvoiceEntityDTO {
  Id: string;
  Title: string;
  Amount: number;
  LicenseNumberName: string;
  LicenseNumber: string;
  CompanyName: string;
  ContactDetails: string;
  CompanyAddress: Address;
  CompanyPhoneNo: String | any;
  CompanyEmail: string;
  CompanyWebsite: string;
  CustomerFirstName: string;
  CustomerLastName: string;
  Introduction: string;
  CustomerAddress: any;
  CustomerBillingAddress: any;
  ShowBillingAddressToCustomer: boolean;
  ProjectName: string;
  ProjectNumber: string;
  ProjectAddress: any;
  ShowProjectInfoToCustomer: boolean;
  CustomerCanViewInvoice: boolean;
  TaxId: string;
  CustomerId: string;
  ProjectId: string;
  CompanyLogo: string;
  InvoiceFiles: EstimateFilesDTO
  InvoiceNumber: string;
  IsSetDateWhenInvoiceSent: boolean = true;
  IsPercentage: boolean = false;
  InvoiceDate: Date = new Date();
  InvoiceDueDate: Date;
  Status: InvoiceStatusEnum = InvoiceStatusEnum.Draft;
  InvoiceTerm: InvoiceTermEnum;
  AdditionalLineItems: InvoiceAdditionalLineItemsDTO[] = [];
  EstimatedLineItems: InvoiceEstimatedLineItemsDTO[]; //The estimate cost-line or section items
  Description: string = '';
  EstimateId: string;
  CompanyLogoFile: Files = {} as Files;
  PortalUrl?: string;
  PortalUrlId?: string;
  StatusProps?: EstimateStatusProps;
  Payments: IPayment[];
  Tax: TaxEntity;
  OtherInvoices: InvoiceEntityDTO[];
  AllInvoices: InvoiceEntityDTO[];
  InvoiceCardOption: DropDownDTO;

  //derived fields
  SubTotal: number = 0;
  TaxableSubTotal: number = 0;
  Total: number = 0;
  RemainingBalance: number = 0;
  PaymentToDate: number = 0;
  CalculatedTax: number = 0;
  TaxRoundingAdjustment: number = 0;
  CompanyFileLogo: Files;
  EstimateEntity: EstimateEntityDTO;
  CreatedDate: Date;
  UpdatedDate: Date;

  EstimatedLineItemsSubTotal = 0;
  EstimatedLineItemsTotal = 0;
  EstimatedLineItemsTotalPercent = 0;

  OtherInvoicedAmt = 0;
  OtherInvoicedAmtPercent = 0;
  OtherAdditionalAmt = 0;
  TotalInvoicedAmtWithoutTax = 0;
  TotalInvoicedAmtWithTax = 0;
  TotalPercentCompleteWithoutTax = 0;
  RequireTaxPerItemizedCostLineIsDisabled:boolean=true;
  TotalPayment: number = 0;
  OtherInvoicesTotal = 0;
  EstimateProjectBalance = 0;
  InvoicePercentage: any;
  InvoiceDiscounts: any[];
  TotalDiscount = 0;

  ForceComplete?: boolean;
  TaxableGapDueToDiscount: number;
  TotalEstimated: number;
  ProjectDiscounts: number;




  constructor() {
    this.AdditionalLineItems = [];
    this.EstimatedLineItems = [];
    this.OtherInvoices = [];
  }
}

export class InvoiceAdditionalLineItemsDTO {
  Id: string;
  Name: string = '';
  Description: string;
  Price: number;
  IsTaxable: boolean;
  IsTaxCompanyCostOnly: boolean;
  IsViewable: boolean;
  QtyIsVisible: boolean;
  Order: number;
  IsTemplate: boolean;
  Vendor: string;
  Sku: string;
  DefaultQty: number;
  DefaultCostPer: number;
  MinimumMarkupType: string;
  MinimumMarkupPer: number;
  DefaultMarkupType: string;
  DefaultMarkupPer: number;
  SourceUrl: string;
  CategoryId: string;
  TradeId: string;
  UnitType: string;
  OnlyShowCategoryName: boolean;
  EstimateDetailsSectionId?: string;
  MovedFrom: string;
  LineItemTaxableAmount?:number;
  Tax?: TaxEntity;
  TaxId?: string;
  LineItemTaxAmount?: number;
}

//This DTO is used to hold estimated cost line or sections data
export class InvoiceEstimatedLineItemsDTO {
  Id: string;
  Name: string;
  Description: string;
  InvoicedPrice: number;
  SectionId: string; // If non itemized then costlines combine to section
  CostLineId: string; // If Itemized then it will show costline wise
  EstimateType: EstimateDetailTypeEnum;
  EstimateDetailName: string;
  EstimateDetailId: string;
  EstimateDetailCreatedDate: Date;
  IsTaxable: boolean;

  //derived fields
  CostlineOrSectionName: string;
  InvoicedPricePercent: number;
  CostlineTax: number;
  LineItemTax: number;
  CostlineTaxableAmt: number;
  LineItemTaxableAmt: number;
  CostlineAmt: number;
  TotalPercentComplete: number;
  TotalInvoiced: number;
  TotalInvoicedPercent: number;
  OtherInvoiced: number;
  OtherInvoicedPercent: number;
  IsCompleted: boolean;

  // extra items
  Icon: string;
  IsDisplayOnly: boolean;
  IsRemovedFromChangeOrder: boolean;
  Order:number
  SectionWiseOrder:number
  SectionCostlineNameDesc: string;



}

export interface InvoiceStatusPropsDTO {
  key: InvoiceStatusEnum,
  icon: string,
  text: string,
  color: string
}
